<template>
  <v-card class="item" flat tile>
    <img
      class="d-block item-img"
      :src="files + img"
      :alt="title"
      width="100%"
      height="100%"
    />
  </v-card>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  .item-img {
    aspect-ratio: 16 / 9;
    object-fit: contain;
  }
}
</style>
